module.exports = __webpack_public_path__ + "img/412.9fbe7682.jpg";